import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { IFAQResponse } from "../../Orchestrator/Types/Interface/ICmsGroupBooking";

export async function getCmsGroupBooking(): Promise<
  IApiResponse<IFAQResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsGroupBookingAPI;

  const locale = (await getLocaleFromCookie()) || "en";
  const params = new URLSearchParams();

  const populateFields = [
    "banner",
    "faqs",
  ];

  params.append("locale", locale);
  populateFields.forEach((field) => params.append("populate", field));

  const endpointWithParams = `${endpoint}?${params.toString()}`;

  return await cmsApiRequest<IFAQResponse>(
    endpointWithParams,
    "GET"
  );
}